export const CalendarSelect = ({ catalog, value, onChange, testId, label = "Calendar edition" }) => (
  <label className="flex min-w-0 flex-col gap-2 text-xs font-semibold text-marian">
    <span>{label}</span>
    <select value={value} onChange={(e) => onChange(e.target.value)} data-testid={testId} className="min-w-0 w-full rounded-lg border border-marian/25 bg-white px-3 py-3 text-sm text-midnight focus:outline-gold">
      <option value="all">All calendars</option>
      <optgroup label="Roman calendars">
        {catalog.filter((c) => c.family === "west").map((c) => <option value={c.id} key={c.id}>{c.label}</option>)}
      </optgroup>
      <optgroup label="Eastern Catholic calendars · 2026 editions">
        <option value="eastern">All seven Eastern calendars</option>
        {catalog.filter((c) => c.family === "east").map((c) => <option value={c.id} key={c.id}>{c.label}</option>)}
      </optgroup>
      <optgroup label="Local devotion">
        {catalog.filter((c) => c.family === "devotion").map((c) => <option value={c.id} key={c.id}>{c.label}</option>)}
      </optgroup>
    </select>
  </label>
);